import SellerBlock from './SellerBlock.vue'

export default SellerBlock
